import globalStorage from '../global-storage';
import React from "react";
import { useNavigate } from "react-router-dom";

function Fetures(props) {
    const navigate = useNavigate();

    return (
        <>
            <section id="fetures" style={{ marginTop: 0, padding: 50 }}>
                <div className="section-title">
                    <h1>{globalStorage.moverstripFetures.title}</h1>
                    <p>{globalStorage.moverstripFetures.subTitle}</p>
                </div>

                <div className='row justify-content-center'>
                    {globalStorage.moverstripFetures.serviceCat.map((item, index) => (
                        <div
                            className='col-xs-6 col-sm-3 col-md-3 mt-2'
                            key={index}
                            style={{ cursor: "pointer" }}
                        >
                            <div className="card" style={{ width: "100%", padding: "10px 0" }}>
                                {/* Title */}
                                <h6 style={{ 
                                    textAlign: 'center', 
                                    color: '#0d6efd', 
                                    marginTop: 10, 
                                    fontWeight: 'bold' 
                                }}>
                                    {item.title}
                                </h6>

                                {/* Image */}
                                <img
                                    src={item.title === "Rate Card" ? "/assets/ratecard.png" : item.Image}
                                    style={{ 
                                        width: "35%", 
                                        margin: "10px auto", 
                                        display: "block" 
                                    }}
                                    className="card-img-top"
                                    alt={item.title}
                                    onClick={() => {
                                        if (item.link) navigate(item.link);
                                    }}
                                />

                                {/* Button */}
                                {item.playStore && (
                                    <div style={{ textAlign: 'center', marginBottom: 15 }}>
                                        <a
                                            href={item.playStore.url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="btn btn-primary btn-sm"
                                            style={{ borderRadius: 10 }}
                                        >
                                            {item.playStore.text}
                                        </a>
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                </div>

                {/* 🚀 Promotional paragraph below all cards */}
        <div style={{ textAlign: "center", marginTop: 60 }}>
          <p style={{ fontSize: 18, fontWeight: 500 }}>
            Promote your <strong>Transport Business</strong> with{" "}
            <strong>MoversTrip</strong> —
            <a
              href="/contact-us"
              style={{
                color: "#0d6efd",
                textDecoration: "none",
                marginLeft: 5,
                fontWeight: "bold",
              }}
            >
              Contact us today!
            </a>
          </p>
        </div>
            </section>
        </>
    );
}

export default Fetures;
